import "../../../css/tailwind.frontend.css";

import "./modules/instantiation.js";

import ProjectsHandler from "./modules/ProjectsHandler.js";

// Import animation related stuff
import CA_Animator from "./modules/Animations/CA_Animator";
import CA_NumbersAnimation from "./modules/Animations/CA_NumbersAnimation";
import CA_FadeAnimation from "./modules/Animations/CA_FadeAnimation";
import CA_HorizontalRuleAnimation from "./modules/Animations/CA_HorizontalRuleAnimation";

const projectsHandler = new ProjectsHandler();

let config = {
	stopAfterIntersecting: true,
	duration: 1500,
	observerConfig: {
		rootMargin: "0px 0px -200px 0px",
		threshold: 0.2,
	},
};


// Create animator object
const animator = new CA_Animator([new CA_NumbersAnimation(config), new CA_FadeAnimation(config), new CA_HorizontalRuleAnimation(config)]);
animator.initialiseAnimations();
